<template>
  <div class="flex w-full justify-center">
    <div class="relative w-full max-w-3xl">
      <div class="relative rounded-lg w-full text-gray-600">
        <input
          v-model="searchValue"
          @keyup="searching()"
          @keyup.enter="handleEnterPress"
          type="text"
          class="block h-12 w-full rounded-lg border-gray-300 pl-10 sm:text-sm"
          placeholder="Search for articles"
        />
        <div
          class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-gray-600"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-6 h-6"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
            />
          </svg>
        </div>
      </div>
      <div
        v-if="showSearchResults()"
        class="absolute w-full bg-white text-gray-600 text-left rounded shadow mt-2 p-3"
      >
        <ul class="space-y-5">
          <li v-for="article in articles">
            <NuxtLink :to="`/${article.full_slug}`">
              <p class="cursor-pointer text-sm">
                {{ article.name }}
              </p>
            </NuxtLink>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
const knowledgeStore = useKnowledgeStore();
const articles = ref([]);
const searchValue = ref("");
const searchTypingTimer = ref(null);
const doneSearchTypingInterval = ref(600);

function showSearchResults() {
  return articles.value.length > 0;
}

// Add new keyup handler for live search
function searching() {
  clearTimeout(searchTypingTimer.value);
  searchTypingTimer.value = setTimeout(async () => {
    if (searchValue.value === "") {
      articles.value = [];
      return;
    }
    await startSearch();
  }, doneSearchTypingInterval.value);
}

async function handleEnterPress() {
  if (searchValue.value === "") {
    articles.value = [];
    return;
  }

  clearTimeout(searchTypingTimer.value);
  await startSearch();
  
  // Update the knowledge store with search results
  knowledgeStore.articles = articles.value;
}

async function startSearch() {
  await searchArticles();
}

const storyblokApi = useStoryblokApi();

async function searchArticles() {
  const { data } = await storyblokApi.get("cdn/stories", {
    version: useRuntimeConfig().public.storyblokVersion,
    starts_with: "knowledge",
    is_startpage: false,
    filter_query: {
      title: {
        like: `*${searchValue.value}*`,
      },
    },
  });
  articles.value = data.stories;
}
</script>
